import { initAccordion } from './lib-2sxc-accordion';

var winAny = window as any;
winAny.appAccordion4 ??= {};
winAny.appAccordion4.init ??= initAccordion;